<template>
    <v-app>
        <v-dialog
            v-model="$store.getters['CreateAudienceStore/getModalStatus']"
            persistent
            fullscreen
            hide-overlay
            transition="slide-x-reverse-transition"
            scrollable
            :content-class="isMobile"
        >
            <v-card tile>
                <v-toolbar
                    flat
                    dark
                    color="primary"
                >
                    <v-toolbar-title>Create Custom Audience</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="close()"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <div class="card createActivation">
                        <div class="card-body">
                            <v-form ref="form">
                                <div class="row" v-if="message">
                                    <div class="col-12">
                                        <div class="alert alert-warning" role="alert">
                                            <i class="fas fa-exclamation-triangle mr-2"></i>
                                            <span>{{ message }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-inline col-md-2">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Custom audience name.</span>
                                        </v-tooltip>

                                        <i class="fas fa-cog" ></i> <span style="padding-left: 5px;"> General</span>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <v-text-field
                                            v-model="description"
                                            label="Audience Name"
                                            :rules="[requiredName]"
                                            :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('description_0')"
                                            :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('description_0')"
                                        ></v-text-field>
                                    </div><!--form-group-->
                                </div>

                                <div class="activation-item-container-2">
                                    <div class="row">
                                        <div class="form-inline col-md-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="grey lighten-1" class="tooltip-small">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Choose from the existing data-types.</span>
                                            </v-tooltip>

                                            <i class="fa fa-tasks"></i> <span style="padding-left: 5px;"> Data Set Type</span>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <v-autocomplete
                                                v-model="analysis_type_0"
                                                :items="$store.getters['CreateAudienceStore/getAnalysisTypes'](0)"
                                                label="Data Type"
                                                :rules="[requiredAnalysisType]"
                                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('analysis_type_0')"
                                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('analysis_type_0')"
                                            ></v-autocomplete>
                                        </div><!--form-group-->
                                    </div>

                                    <LocationData
                                        v-if="[
                                            analyses.types.poi,
                                            analyses.types.cohorts,
                                            analyses.types.competitors,
                                            analyses.types.anonymized
                                            ].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                        data-set-order="0"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                    ></LocationData>

                                    <AnonymizedFields
                                        v-if="[
                                            analyses.types.anonymized
                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                        data-set-order="0"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                    ></AnonymizedFields>

                                    <AppsData
                                        v-if="[analyses.types.apps].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                        data-set-order="0"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                    ></AppsData>

                                    <CompetitorsData
                                        v-if="[analyses.types.competitors].includes(analysis_type_0)"
                                        data-set-order="comp_0"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                    ></CompetitorsData>

                                    <Distance
                                        v-if="[analyses.types.competitors].includes(analysis_type_0)"
                                        data-set-order="comp_0"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                    ></Distance>
                                </div>

                                <Recency
                                    v-if="[
                                        analyses.types.poi,
                                        analyses.types.apps,
                                        analyses.types.anonymized,
                                        analyses.types.competitors
                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                    data-set-order="0"
                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                ></Recency>

                                <Limits
                                    v-if="[
                                        analyses.types.poi,
                                        analyses.types.competitors
                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                    data-set-order="0"
                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                ></Limits>

                                <div class="row" v-if="[analyses.types.poi, analyses.types.apps, analyses.types.competitors, analyses.types.cohorts].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))">
                                    <div class="form-inline col-md-2">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Select if you want to cross audiences with different operators.</span>
                                        </v-tooltip>

                                        <i class="fas fa-database"></i> <span style="padding-left: 5px;">Operator</span>
                                    </div>

                                    <div class="col-md-10 queryButtons">
                                        <v-radio-group row v-model="query">
                                            <v-radio
                                                label="None"
                                                value="Single"
                                                active-class="checked"
                                                @click="$store.commit('CreateAudienceStore/SET_QUERY', 'Single')"
                                            ></v-radio>
                                            <v-radio
                                                label="AND"
                                                value="AND"
                                                active-class="checked"
                                                @click="$store.commit('CreateAudienceStore/SET_QUERY', 'AND')"
                                            ></v-radio>
                                            <v-radio
                                                label="OR"
                                                value="OR"
                                                active-class="checked"
                                                @click="$store.commit('CreateAudienceStore/SET_QUERY', 'OR')"
                                            ></v-radio>
                                            <v-radio
                                                label="NOT IN"
                                                value="NOTIN"
                                                active-class="checked"
                                                @click="$store.commit('CreateAudienceStore/SET_QUERY', 'NOTIN')"
                                            ></v-radio>
                                        </v-radio-group>
                                    </div>
                                </div>

                                <div class="activation-item-container-2" v-if="$store.getters['CreateAudienceStore/getQuery'] !== 'Single' && $store.getters['CreateAudienceStore/getAnalysisType'](0) !== analyses.types.anonymized">
                                    <div class="row">
                                        <div class="form-inline col-md-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="grey lighten-1" class="tooltip-small">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Choose from the existing data-types.</span>
                                            </v-tooltip>

                                            <i class="fa fa-tasks"></i> <span style="padding-left: 5px;"> Data Set Type</span>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <v-autocomplete
                                                v-model="analysis_type_1"
                                                :items="$store.getters['CreateAudienceStore/getAnalysisTypes'](1)"
                                                label="Data Type"
                                                :rules="[requiredAnalysisType]"
                                            ></v-autocomplete>
                                        </div><!--form-group-->
                                    </div>

                                    <LocationData
                                        v-if="[
                                            analyses.types.poi,
                                            analyses.types.cohorts,
                                            analyses.types.competitors,
                                            ].includes($store.getters['CreateAudienceStore/getAnalysisType'](1))"
                                        data-set-order="1"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                    ></LocationData>

                                    <AnonymizedFields
                                        v-if="[
                                            analyses.types.anonymized
                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](1))"
                                        data-set-order="1"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                    ></AnonymizedFields>

                                    <AppsData
                                        v-if="[analyses.types.apps].includes($store.getters['CreateAudienceStore/getAnalysisType'](1))"
                                        data-set-order="1"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                    ></AppsData>

                                    <CompetitorsData
                                        v-if="[analyses.types.competitors].includes(analysis_type_1)"
                                        data-set-order="comp_1"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                    ></CompetitorsData>

                                    <Distance
                                        v-if="[analyses.types.competitors].includes(analysis_type_1)"
                                        data-set-order="comp_1"
                                        :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                    ></Distance>
                                </div>

                                <Recency
                                    v-if="[
                                        analyses.types.poi,
                                        analyses.types.apps,
                                        analyses.types.competitors
                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](1)) &&
                                        $store.getters['CreateAudienceStore/getQuery'] !== 'Single'"
                                    data-set-order="1"
                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                ></Recency>

                                <Limits
                                    v-if="[
                                        analyses.types.poi,
                                        analyses.types.competitors
                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](1))"
                                    data-set-order="1"
                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                ></Limits>

                                <Filters
                                    v-if="[
                                        $store.getters['CreateAudienceStore/getAnalysisType'](0),
                                        $store.getters['CreateAudienceStore/getAnalysisType'](1)
                                        ].includes(analyses.types.poi) ||
                                        [
                                        $store.getters['CreateAudienceStore/getAnalysisType'](0),
                                        $store.getters['CreateAudienceStore/getAnalysisType'](1)
                                        ].includes(analyses.types.competitors) ||
                                        $store.getters['CreateAudienceStore/getAnalysisType'](0) === analyses.types.anonymized"
                                    data-set-order="0"
                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                ></Filters>

                                <div class="row" v-if="$store.getters.getUserPermissions.includes('frontend-data-explorer-analyses-cohorts') && $store.getters['CreateAudienceStore/getAnalysisType'](0) !== analyses.types.anonymized">
                                    <div class="form-inline col-md-2">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Save this custom audience as a cohort <br> (group of mobile devices) to analyze it later.</span>
                                        </v-tooltip>

                                        <i class="fas fa-layer-group"></i> <span style="padding-left: 5px;">Create Cohort </span>
                                    </div>

                                    <div class="form-group col-md-2 push-down-36">
                                        <v-switch
                                            v-model="create_cohort"
                                            inset
                                        ></v-switch>
                                    </div><!--form-group-->
                                </div>

                                <AnalysesSelection
                                    v-if="$store.getters['CreateAudienceStore/getAnalysisType'](0) !== analyses.types.anonymized"
                                ></AnalysesSelection>

                                <CrossVisitation
                                    v-if="$store.getters['CreateAudienceStore/getAnalysesCrossVisitationStatus']"
                                    :row-style="{ backgroundColor: colors.cv_bg }"
                                ></CrossVisitation>

                                <Frequency
                                    v-if="$store.getters['CreateAudienceStore/getAnalysesFrequencyStatus']"
                                    :row-style="{ backgroundColor: colors.fq_bg }"
                                ></Frequency>

                                <div class="row">
                                    <div class="form-inline col-md-2">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Receive email upon completion.</span>
                                        </v-tooltip>

                                        <i class="fas fa-envelope-open-text"></i> <span style="padding-left: 5px;">Notification</span>
                                    </div>

                                    <div class="form-group col-md-2 push-down-36">
                                        <v-switch
                                            v-model="notification"
                                            inset
                                        ></v-switch>
                                    </div><!--form-group-->
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-1 text-left">
                                        <button @click.prevent="close()" class="btn btn-danger">Cancel</button>
                                    </div>
                                    <div class="col-2 offset-9 text-right">
                                        <button @click.prevent="submitData" :disabled="submitted" class="btn btn-success">
                                            <v-progress-circular
                                                v-if="submitted"
                                                :width="2"
                                                :size="20"
                                                indeterminate
                                                color="#ffffff"
                                                class="mr-2"
                                            ></v-progress-circular>
                                            {{ create_button_text }}
                                        </button>
                                    </div>
                                </div>
                            </v-form>
                        </div>
                    </div><!--card-->
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import Modal from '../Modal'
import Recency from "./partials/shared/Recency";
import LocationData from "./partials/poi/LocationData";
import Distance from "./partials/competitors/Distance"
import Filters from "./partials/shared/Filters"
import analyses from "../../mixin/analyses"
import {fetchAnalysisTypes} from "../../store/modules/CreateAudience/actions";
import Limits from "./partials/shared/Limits";
import AnalysesSelection from "./partials/shared/analyses/AnalysesSelection";
import Frequency from "./partials/shared/analyses/Frequency";
import CrossVisitation from "./partials/shared/analyses/CrossVisitation";
import CompetitorsData from "./partials/competitors/CompetitorsData.vue";
import AppsData from "./partials/create/apps/AppsData.vue";
import AnonymizedFields from "./partials/create/anonymized/AnonymizedFields.vue";
export default {
    name: "CreateNewPrivateAudience",
    mixins: [analyses],
    components: {
        AnonymizedFields,
        AppsData,
        CompetitorsData,
        CrossVisitation,
        Frequency,
        AnalysesSelection,
        Limits,
        Modal,
        Recency,
        LocationData,
        Distance,
        Filters
    },
    data: () => ({
        is_field_loading: true,

        submitted: false,
        requiredName: v => v && v.length > 0 || 'Audience Name field is required',
        requiredAnalysisType: v => v && v.length > 0 || 'Data Sets field is required',
    }),
    methods: {
        submitData() {
            if (this.$refs.form.validate()) {
                this.submitted = true
                this.mergeLocations()
                this.mergeBundleIds()
                this.$store.dispatch('CreateAudienceStore/createNewAudience')
            }
        },
        close() {
            this.$store.commit('CreateAudienceStore/RESET_STATE')
            this.$store.commit('CreateAudienceStore/SET_MODAL', false)
        },
        mergeLocations() {
            this.$store.dispatch('CreateAudienceStore/mergeLocationIds', 0)
            this.$store.dispatch('CreateAudienceStore/mergeLocationIds', 1)
            this.$store.dispatch('CreateAudienceStore/mergeLocationIds', 'cross')
        },
        mergeBundleIds() {
            this.$store.dispatch('CreateAudienceStore/mergeBundleIds', 0)
            this.$store.dispatch('CreateAudienceStore/mergeBundleIds', 1)
        }
    },
    computed: {
        create_button_text() {
            if (this.submitted) {
                return "Creating"
            } else {
                return "Create"
            }
        },
        query: {
            get() {
                return this.$store.getters['CreateAudienceStore/getQuery']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_QUERY', value)
            }
        },
        description: {
            get() {
                return this.$store.getters['CreateAudienceStore/getActivationName']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_NAME', value)
            }
        },
        notification: {
            get() {
                return this.$store.getters['CreateAudienceStore/getNotificationStatus']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_NOTIFICATION', value)
            }
        },
        create_cohort: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCreateCohortStatus']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_CREATE_COHORT', value)
            }
        },
        analysis_type_0: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysisType'](0)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSIS_TYPE', {
                    dataset: 0,
                    value: value
                })
            }
        },
        analysis_type_1: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysisType'](1)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSIS_TYPE', {
                    dataset: 1,
                    value: value
                })
            }
        },
        message() {
            return this.$store.getters['CreateAudienceStore/getMessage']
        }
    },
    watch: {
        //
    },
    created() {
        if (this.$store.getters.getNotificationsPreferences.email.audiences_custom_audiences) {
            this.$store.commit('CreateAudienceStore/SET_NOTIFICATION',
                this.$store.getters.getNotificationsPreferences.email.audiences_custom_audiences
            )
        }
    },
    mounted() {
        this.$store.dispatch('CreateAudienceStore/fetchAnalysisTypes')
    }
}
</script>

<style>
.v-sheet header {
    max-height: 65px !important;
}

.v-dialog__content--active {
    z-index: 99998 !important;
}

.push-10 {
    padding-left: 10% !important;
    margin-top: 55px !important;
}

.push-20 {
    padding-left: 30% !important;
    margin-top: 55px !important;
}

.push-30 {
    padding-left: 20% !important;
    margin-top: 55px !important;
}

.push-40 {
    padding-left: 40% !important;
    margin-top: 55px !important;
}

.push-50 {
    padding-left: 50% !important;
    margin-top: 55px !important;
}
.tooltip-small {
    font-size: 18px !important;
}

.push-down-36 {
    margin-top: 36px;
}

.v-input--selection-controls {
    margin-top: 1px;
}

.v-date-picker-table {
    height: auto !important;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
}

.card {
    border: none;
}

.v-input--radio-group__input .checked label {
    background-color: #ff7516;
    border-color: #ff7516;
    color: #fff;
}

.v-input__slot .v-label {
    margin-bottom: 0;
}

.v-input--radio-group__input .v-radio .v-input--selection-controls__input {
    display: none;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 32px;
    padding: 0 12px;
}

.v-dialog__content--active {
    z-index: 99998 !important;
}

.recency-options > span {
    color: #ff7516;
    border-bottom: 1px solid white;
    transition: border-bottom .3s ease-in-out;
}

.recency-options > span:hover {
    border-bottom: 1px solid #ff7516;
    cursor: pointer;
}
</style>